export enum INotificationCollectionName {
  courtsReservations = "courtsReservations",
}

export enum INotificationType {
  ANNOUNCMENTS = "ANNOUNCMENTS",
  coach_reservation = "coach_reservation",
  // visit_request = "visit_request",
  // order = "order",
  // team_invitation = "team_invitation",
  // applied_team = "applied_team",
}

export enum INotificationEvent {
  ANNOUNCMENT_CREATED = "ANNOUNCMENT_CREATED",
  reserved = "reserved",
  canceled = "canceled",
  // reminder = "reminder",
  // accepted = "accepted",
  // rejected = "rejected",
  // approved = "approved",
  // delivering = "delivering",
  // rejected = "rejected",
  // invite = "invite",
  // done = "done",
  // accepted = "accepted",
}

export enum INotificationUserType {
  sportClub = "sportClub",
}

export type NotificationCollectionName = keyof typeof INotificationCollectionName;
export type NotificationType = keyof typeof INotificationType;
export type NotificationEvent = keyof typeof INotificationEvent;
export type NotificationUserType = keyof typeof INotificationUserType;

export interface INotificationData {
  id: string;
  path: string;
  type: NotificationType;
  event: NotificationEvent;
  collectionName: NotificationCollectionName;
  userType: NotificationUserType;
}

export interface INotificationPayload {
  data: INotificationData;
  fcmMessageId: string;
  from: string;
  priority: string;
}
